import SingleSlideView from "@features/media-academy/view/single-view";

const SingleSlide = () => {
  return <SingleSlideView />;
};

export default SingleSlide;
